import { COLOR, Icon as _Icon, ICON_SIZE, Tooltip2 as _Tooltip2 } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { Z_INDEX } from "~/styles/z-index";

// PCとTabletサイズの場合のstyle
export const DivPcAndTabletRoot = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
  height: 48px;
`;

export const ButtonShare = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ButtonPlayWithApplication = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
`;

export const ButtonDownload = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 16px;

  &:disabled {
    pointer-events: none;
    opacity: 0.4;
  }
`;

export const ButtonFavorite = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const DivButtonShare = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  // MEMO : シェアボタンは必ず表示されるので一律でmargin-leftを指定する
  margin-left: 16px;

  &:focus-visible {
    outline: 2px solid ${COLOR.YELLOW900.code};
    outline-offset: -2px;
  }
`;

export const PcIcon = styled(_Icon)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${ICON_SIZE.XXXL.width}px;
  height: ${ICON_SIZE.XXXL.height}px;
  background-color: ${COLOR.GRAY900.code};
  border-radius: 50%;
`;

export const ParIconName = styled.p`
  margin-top: 4px;
  font-size: 8px;
  color: ${COLOR.GRAY500.code};
  white-space: nowrap;
`;

export const Tooltip2 = styled(_Tooltip2)`
  display: grid;
  grid-template-columns: repeat(3, auto);
  justify-content: center;
  align-items: center;
  column-gap: 16px;
  padding: 16px;
  z-index: ${Z_INDEX.TOOLTIP};
  &:before {
    top: -12px;
    border-width: 0 8px 12px;
    right: 16px;
  }
`;
